module.exports = __webpack_public_path__ + "static/media/impressum_headerimage.7dc408fc.jpg";


//////////////////
// WEBPACK FOOTER
// /src/images/impressum_headerimage.jpg
// module id = 744
// module chunks = 0